<template>
  <div class="d-flex relative ml-3">
    <v-divider v-if="mdAndUp" vertical class="mr-6 grey lighten-3"></v-divider>

    <div class="search" v-click-outside="hideSearch">
      <v-slide-x-reverse-transition>
        <form v-if="opened" @submit="submit" class="search-form">
          <v-text-field
            autofocus
            v-model="q"
            placeholder="Faça sua Busca"
            background-color="#ffffff"
            dense
            ref="search"
            hide-details
            outlined
            filled
            min-height="40px"
            height="40px"
            name="q"
          ></v-text-field>
          <v-btn
            class="primary--text"
            min-width="40px"
            color="white"
            height="40px"
            type="submit"
            width="40px"
            depressed
            tile
          >
            <v-icon size="18"> fa fa-search </v-icon>
          </v-btn>
        </form>
      </v-slide-x-reverse-transition>

      <v-btn
        @click="opened = !opened"
        class="primary--text"
        min-width="40px"
        color="transparent"
        height="40px"
        width="40px"
        depressed
        tile
      >
        <v-icon size="18"> {{ opened ? "fa-times" : "fa-search" }} </v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    q: "",
    opened: false,
  }),
  computed: {
    mdAndUp() {
      return this.$vuetify.breakpoint.mdAndUp;
    },
  },
  methods: {
    hideSearch() {
      if (this.opened) this.opened = false;
    },
    submit(event) {
      if (this.q) this.$router.push(`/busca?q=${this.q}`);
      event.preventDefault();
    },
  },
  watch: {
    $route() {
      if (this.$route.query.q) this.q = this.$route.query.q;
    },
  },
};
</script>

<style lang="scss" scoped>
.search-form {
  background-color: white;
  border-radius: 4px;
  display: grid;
  grid-template-columns: auto 40px;
  margin-right: 1px;
  position: absolute;
  right: 100%;
  top: 0;
  width: 300px;
  @media screen and (max-width: 415px) {
    left: 15px;
    margin-top: 10px;
    position: fixed;
    right: 15px;
    top: 100%;
    width: auto;
  }
}
</style>
